import { EContractorPaymentStatus } from "./EContractorPaymentStatus";
import { EContractorPaymentType } from "./EContractorPaymentType";
import { EPaymentItemCategory } from "./EPaymentItemCategory";
import { EPaymentItemEarningType } from "./PaymentItemEarningType";

export const getPaymentTypeLabel = (type: EContractorPaymentType) => {
  switch (type) {
    case EContractorPaymentType.REGULAR:
      return "Regular";
    case EContractorPaymentType.REIMBURSEMENT:
      return "Reimbursement";
    case EContractorPaymentType.KIT:
      return "Kit";
    case EContractorPaymentType.ALL:
      return "Mixed";
    default:
      return "Unknown";
  }
};

export const getPaymentItemTypeLabel = (type?: EPaymentItemEarningType) => {
  if (!type) {
    return "-";
  }
  switch (type) {
    case EPaymentItemEarningType.HOURLY:
      return "Hourly";
    case EPaymentItemEarningType.PER_UNIT:
      return "Per unit";
    case EPaymentItemEarningType.FLAT_FEE:
      return "Flat amount";
    case EPaymentItemEarningType.EXPENSE_REIMBURSEMENT:
      return "Expense reimbursement";
    case EPaymentItemEarningType.BONUS:
      return "Bonus";
    default:
      return "Unknown";
  }
};

export const getDefaultPaymentItemCategoryForContractorPaymentType = (
  type: EContractorPaymentType
): EPaymentItemCategory => {
  switch (type) {
    case EContractorPaymentType.KIT:
      return EPaymentItemCategory.KIT;
    case EContractorPaymentType.REIMBURSEMENT:
      return EPaymentItemCategory.REIMBURSEMENT;
    case EContractorPaymentType.ALL:
    case EContractorPaymentType.REGULAR:
    default:
      return EPaymentItemCategory.REGULAR;
  }
};

export const getContractorPaymentStatusLabel = (
  status: EContractorPaymentStatus
) => {
  switch (status) {
    case EContractorPaymentStatus.pending:
      return "Pending";
    case EContractorPaymentStatus["pre-processing"]:
      return "Pre-processing";
    case EContractorPaymentStatus["pre-processed"]:
      return "Pre-processed";
    case EContractorPaymentStatus.processed:
      return "Processed";
    case EContractorPaymentStatus.processing:
      return "Processing";
    case EContractorPaymentStatus.voided:
      return "Voided";
    case EContractorPaymentStatus.failed:
      return "Failed";
    default:
      return "Pending";
  }
};
